import i18next from "i18next"

export const policyFileName = (): string => {
  const currentLang = i18next.language

  return currentLang === "en"
    ? "2_9politika_pdn__eng.pdf"
    : "iblock/18c/4r3ynzhxj3h43vlyw717eexit3vtb2tf/2026_05_21_politika_PDn.pdf"
}

export const agreementFileName = (): string => {
  const currentLang = i18next.language

  return currentLang === "en" ? "agreement_eng.pdf" : "agreement_ru.pdf"
}
